import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconsModule } from '../../../icons/icons.module';

@Component({
  selector: 'zikatagov-empty-state',
  standalone: true,
  imports: [CommonModule, IconsModule],
  template: `
    <div
      class="d-flex flex-column align-items-center justify-content-center p-4 m-3 bg-white rounded"
    >
      <div class="mb-4">
        <ng-icon [name]="icon" class="text-pink" size="100"></ng-icon>
      </div>

      <h4 class="fw-semibold fw-light text-plum-dark mb-4">
        {{ title }}
      </h4>

      <p class="text-grape fw-light text-center mb-2">
        {{ introText }}
      </p>

      <p class="text-grape fw-light text-center mb-4" style="max-width: 480px;">
        {{ description }}
      </p>

      <div class="text-center" *ngIf="instructions.length">
        <p class="text-grape mb-0 small-font fw-light">
          {{ instructionTitle }}
        </p>
        <ul class="list-unstyled text-grape">
          <li
            class="mb-0 small-font fw-light"
            *ngFor="let instruction of instructions"
          >
            {{ instruction }}
          </li>
        </ul>
      </div>

      <button
        *ngIf="showVideo"
        class="btn btn-peach-light mb-4 d-flex text-grape align-items-center justify-content-between py-3 px-5"
      >
        <span class="small-font me-3"> Watch Video </span>
        <ng-icon
          name="saxPlayOutline"
          class="text-pink"
          size="24"
          style="opacity: 0.6; margin-left: 1px"
        ></ng-icon>
      </button>

      <div class="separator w-75 mb-2"></div>

      <p class="text-grape fw-light mb-3 small-font" *ngIf="hasAction">
        {{ ctaText }}
      </p>

      <!-- Primary Action Button -->
      <button
        *ngIf="hasAction"
        class="btn btn-warning text-white ps-5 pe-5 shadow-lg"
        (click)="onActionClick()"
      >
        {{ actionButtonText }}
      </button>
    </div>
  `,
  styleUrls: ['./zikata-empty-state.component.scss'],
})
export class ZikataEmptyStateComponent {
  @Input() icon = 'saxNotificationOutline';
  @Input() title = 'Welcome to Zikata';
  @Input() introText = '';
  @Input() description = '';
  @Input() instructionTitle = '';
  @Input() instructions: string[] = [];
  @Input() showVideo = false;
  @Input() ctaText = 'Tap on the button below to get started';
  @Input() actionButtonText = 'Get Started';
  @Input() hasAction = true;
  @Output() actionClicked = new EventEmitter<void>();

  onActionClick() {
    this.actionClicked.emit();
  }
}
